var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.851758V13.7893C20 14.2597 19.6186 14.6411 19.1482 14.6411C18.6779 14.6411 18.2965 14.2597 18.2965 13.7893V2.90824L1.4541 19.7506C1.28773 19.9169 1.0698 20 0.851797 20C0.633789 20 0.415859 19.9169 0.249492 19.7506C-0.0831641 19.4179 -0.0831641 18.8786 0.249492 18.5459L17.0919 1.70352H6.21066C5.74027 1.70352 5.35891 1.32215 5.35891 0.851758C5.35891 0.381367 5.74027 3.00023e-09 6.21066 3.00023e-09H19.1482C19.6186 -3.90595e-05 20 0.381367 20 0.851758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/arrow-link.663b307d55f0b938a740f98cd179c8d4.svg";
export { ForwardRef as ReactComponent };